import { CreditHoldReason } from "../../../support/models/enums/credit-hold-reason";

export class CreditHoldList {

    public dealerId : string = '';

    public dealerName : string = '';

    public creditHoldReason? : CreditHoldReason = undefined

    public subtotal : number = 0.0;

    public freight : number = 0.0;

    public tax : number = 0.0;

    public total : number = 0.0;

}
